import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { initBoAppCheck, initBoFirebase } from '@bo/core';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Firebase antes del arranque; App Check después (ver initBoAppCheck): el
// dashboard arranca sobre <body> ('body[root]') y Angular vaciaría el div del
// widget de reCAPTCHA. Llegamos a tiempo porque nada toca Firebase durante el
// arranque: AuthService llama a getAuth() dentro de signInWithGoogle() y
// ChatService crea getDatabase() cuando se inyecta, ya con el chat cargado.
const firebaseApp = initBoFirebase(environment);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .then(() => initBoAppCheck(firebaseApp, environment))
  .catch((err) => console.error(err));
